/* eslint-disable @typescript-eslint/no-unused-vars */
import create from "zustand";

import bikesStore, { IBikeStore } from "./modules/bikes.store";

import veiculoPlacaStore, {
  IVeiculoPlacaModuleStore,
} from "./modules/veiculoPlaca.store";

import veiculoChassiStore, {
  IVeiculoChassiModuleStore,
} from "./modules/veiculoChassi.store";

import celularImeiStore, {
  ICelularImeiModuleStore,
} from "./modules/celularImei.store";

import celularNomeStore, {
  ICelularNomeModuleStore,
} from "./modules/celularNome.store";

import civilStore, { ICivilModuleStore } from "./modules/civilNominal.store";
import civilRgStore, { ICivilRGModuleStore } from "./modules/civilRg.store";
import civilCPFStore, { ICivilCPFModuleStore } from "./modules/civilCPF.store";

import listaBuscaStore, {
  IBuscaUsuarioModuleStore,
} from "./modules/listaUsuario.store";

import criminalNominalStore, {
  ICriminalNominalModuleStore,
} from "./modules/criminalNominal.store";

import criminalRCStore, {
  ICriminalRCModuleStore,
} from "./modules/criminalRC.store";

import criminalCPFStore, {
  ICriminalCPFModuleStore,
} from "./modules/criminalCPF.store";

import carcerarioNominalStore, {
  ICarcerarioNominalModuleStore,
} from "./modules/carcerarioNominal.store";

import carcerarioRGStore, {
  ICarcerarioRGModuleStore,
} from "./modules/carcerarioRG.store";

import mandadoNominalStore, {
  IMandadoNominalModuleStore,
} from "./modules/mandadoNominal.store";

import global, { IGlobalStore } from "./modules/global.store";

export interface IAlertaBikeStore {
  global: IGlobalStore;
  bike: IBikeStore;
}

export interface IVeiculoPlacaStore {
  global: IGlobalStore;
  veiculo: IVeiculoPlacaModuleStore;
}

export interface IVeiculoChassiStore {
  global: IGlobalStore;
  veiculo: IVeiculoChassiModuleStore;
}

export interface ICelularImeiStore {
  global: IGlobalStore;
  celular: ICelularImeiModuleStore;
}

export interface ICelularNomeStore {
  global: IGlobalStore;
  celular: ICelularNomeModuleStore;
}

export interface ICivilNominalStore {
  global: IGlobalStore;
  civil: ICivilModuleStore;
}

export interface ICivilRGNominalStore {
  global: IGlobalStore;
  civil: ICivilRGModuleStore;
}

export interface ICivilCPFNominalStore {
  global: IGlobalStore;
  civil: ICivilCPFModuleStore;
}

export interface ICriminalNominalstore {
  global: IGlobalStore;
  criminal: ICriminalNominalModuleStore;
}

export interface ICriminalRCstore {
  global: IGlobalStore;
  criminal: ICriminalRCModuleStore;
}
export interface ICriminalCPFstore {
  global: IGlobalStore;
  criminal: ICriminalCPFModuleStore;
}

export interface ICarcerarioNominalstore {
  global: IGlobalStore;
  carcerario: ICarcerarioNominalModuleStore;
}
export interface ICarcerarioRGstore {
  global: IGlobalStore;
  carcerario: ICarcerarioRGModuleStore;
}

export interface IMandadoNominalstore {
  global: IGlobalStore;
  mandado: IMandadoNominalModuleStore;
}

export interface IBuscaUsuarioStore {
  global: IGlobalStore;
  buscarUsuario: IBuscaUsuarioModuleStore;
}

export const bikeStore = create<IAlertaBikeStore>((set) => ({
  global,
  bike: bikesStore(set),
}));

export const veiculoStorePlaca = create<IVeiculoPlacaStore>((set) => ({
  global,
  veiculo: veiculoPlacaStore(set),
}));

export const veiculoStoreChassi = create<IVeiculoChassiStore>((set) => ({
  global,
  veiculo: veiculoChassiStore(set),
}));

export const celularStoreImei = create<ICelularImeiStore>((set) => ({
  global,
  celular: celularImeiStore(set),
}));

export const celularStoreNome = create<ICelularNomeStore>((set) => ({
  global,
  celular: celularNomeStore(set),
}));

export const civilStoreNominal = create<ICivilNominalStore>((set) => ({
  global,
  civil: civilStore(set),
}));

export const civilStoreRG = create<ICivilRGNominalStore>((set) => ({
  global,
  civil: civilRgStore(set),
}));
export const civilStoreCPF = create<ICivilCPFNominalStore>((set) => ({
  global,
  civil: civilCPFStore(set),
}));

export const criminalStoreNominal = create<ICriminalNominalstore>((set) => ({
  global,
  criminal: criminalNominalStore(set),
}));

export const criminalStoreRC = create<ICriminalRCstore>((set) => ({
  global,
  criminal: criminalRCStore(set),
}));

export const criminalStoreCPF = create<ICriminalCPFstore>((set) => ({
  global,
  criminal: criminalCPFStore(set),
}));

export const carcerarioStoreNominal = create<ICarcerarioNominalstore>(
  (set) => ({
    global,
    carcerario: carcerarioNominalStore(set),
  })
);
export const carcerarioStoreRG = create<ICarcerarioRGstore>((set) => ({
  global,
  carcerario: carcerarioRGStore(set),
}));

export const mandadoStoreNominal = create<IMandadoNominalstore>((set) => ({
  global,
  mandado: mandadoNominalStore(set),
}));

export const buscaUsuariosStore = create<IBuscaUsuarioStore>((set) => ({
  global,
  buscarUsuario: listaBuscaStore(set),
}));
